function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M248.084 96.684h12c4.4 0 8-3.6 8-8s-3.6-8-8-8h-12c-4.4 0-8 3.6-8 8s3.6 8 8 8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M366.484 25.484c-2.8-5.6-8.4-8.8-14.4-8.8h-336c-6 0-11.6 3.6-14.4 8.8-2.8 5.6-2 12 1.6 16.8l141.2 177.6v115.6c0 6 3.2 11.2 8.4 14 2.4 1.2 4.8 2 7.6 2 3.2 0 6.4-.8 9.2-2.8l44.4-30.8c6.4-4.8 10-12 10-19.6v-78.8l140.8-177.2c3.6-4.8 4.4-11.2 1.6-16.8zm-156.8 186.4c-.8 1.2-1.6 2.8-1.6 4.8v81.2c0 2.8-1.2 5.2-3.2 6.8l-44.4 30.8v-118.8c0-2.8-1.2-5.2-3.2-6.4l-90.4-113.6h145.2c4.4 0 8-3.6 8-8s-3.6-8-8-8h-157.6l-38.4-48h336l-142.4 179.2z"
});

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 368.167 368.167",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Filter.07600e6e.svg";
export { ForwardRef as ReactComponent };